import * as React from 'react';
import styled from 'styled-components';
import { withAnalytics, enrichAnalytics, WithAnalyticsProps } from 'react-shisell';
import { compose } from 'recompose';
import { StartTimer } from '@soluto-home-web/platform-utils';
import withContentItemMessageHandlers from '../hoc/withContentItemMessageHandlers';

type Item = {
  id: string;
  url: string;
  header?: string | null;
};

type AnalyticEvent = {
  ExtraData: object;
  Name: string;
  Scope: string;
};

type OuterProps = {
  item: Item;
};

type InnerProps = OuterProps & WithAnalyticsProps;

const Iframe = styled.iframe`
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: block;
  overflow: hidden;
`;

const ContentViewer = ({ analytics, item }: InnerProps) => {
  const timerFunction = StartTimer();
  return (
    <Iframe
      src={item.url}
      frameBorder={0}
      onLoad={() => {
        const milliSecondsDiff = timerFunction.stop('ms');
        analytics.dispatcher
          .withExtras({
            ItemTopic: item.id || '',
            ItemHeader: item.header || '',
            ItemLoadingTime: milliSecondsDiff / 1000,
          })
          .dispatch('View');
      }}
    />
  );
};

export { Item as ContentViewerItem };
export { OuterProps as ContentViewerProps };
export default compose<InnerProps, OuterProps>(
  enrichAnalytics<InnerProps>((dispatcher, { item }) => {
    if (item) {
      return dispatcher.withExtras({
        Url: item.url,
        TopicId: item.id,
      });
    }

    return dispatcher;
  }),
  withAnalytics,
  withContentItemMessageHandlers<InnerProps>({
    analytics: ({ analytics }) => (analyticEvent: AnalyticEvent) => {
      analytics.dispatcher.withExtras(analyticEvent.ExtraData).dispatch(analyticEvent.Name);
    },
  })
)(ContentViewer);



// WEBPACK FOOTER //
// ./packages/platform-common-ui/components/content-viewer/components/ContentViewer.tsx